import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@hivebrite/design-system/Button';
import { toast } from '@hivebrite/design-system/Toast';

import { useMentorshipsContext } from 'hb-react/frontoffice/apps/Mentorships/contexts/MentorshipsContext';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import ModalWithTemplate from 'hb-react/shared/components/DesignSystem/Modal/ModalWithTemplate';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import ApplyToBeMenteeForm from '../Forms/ApplyToBeMenteeForm';

const ApplyToBeMenteeModal = ({ mentor, disabled, setIsPending }) => {
  const navigate = useNavigate();
  const { topicId } = useTopicContext();
  const { mentorLabel, menteeLabel } = useMentorshipsContext();

  const [isOpen, setOpen] = useState(false);

  const onCloseModal = () => {
    setOpen(false);
  };

  const onOpenModal = () => {
    setOpen(true);
  };

  const relationshipsPath = topicId
    ? Routes.topics_topic_relationships_path(topicId)
    : Routes.mentorships_relationships_path();

  const onSubmit = (values) => {
    axios
      .post(relationshipsPath, values)
      .then(() => {
        setIsPending(true);
        navigate(Routes.mentorships_path());
        toast.success(
          s__('Mentorships|Your request has been taken into account'),
        );
      })
      .catch(() => {
        toast.error(__('Sorry, an error occurred'));
      })
      .finally(() => {
        onCloseModal();
      });
  };

  return (
    <>
      <Button onClick={onOpenModal} isDisabled={disabled}>
        {s__('Mentorships|Connect')}
      </Button>
      {isOpen && (
        <ModalWithTemplate
          onCloseModal={onCloseModal}
          header={s__('Mentorships|Contacting %{mentorLabel}').i__({
            mentorLabel: mentorLabel.toLowerCase(),
          })}
          screenReadersCloseButtonText={s__(
            'Accessibility|Close the apply to be a %{menteeLabel} window',
          ).i__({
            menteeLabel: menteeLabel.toLowerCase(),
          })}
        >
          <ApplyToBeMenteeForm
            onSubmit={onSubmit}
            onCancel={onCloseModal}
            mentor={mentor}
          />
        </ModalWithTemplate>
      )}
    </>
  );
};

export default ApplyToBeMenteeModal;
